import { TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import React from "react";

function EnhancedTable(props) {
  const { headerList, dataList, renderRowCells } = props;

  if (dataList?.length === 0) return null;

  return (
    <>
      <TableContainer>
        <Table aria-label="enhanced table">
          <TableHead>
            <Headers list={headerList} />
          </TableHead>
          <TableBody>
            <Rows list={dataList} renderRowCells={renderRowCells} />
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

function Headers(props) {
  return (
    <TableRow>
      {props.list.map((h) => (
        <TableCell key={h.label} align={h.align}>
          {h.label}
        </TableCell>
      ))}
    </TableRow>
  );
}

function Rows(props) {
  const { list, renderRowCells } = props;
  const classes = useRowStyles();

  return (
    <>
      {list.map((l, i) => (
        <TableRow key={l.id} style={{ backgroundColor: i % 2 ? "#e1e1e1" : "white" }} className={classes.root}>
          {renderRowCells(l)}
        </TableRow>
      ))}
    </>
  );
}

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset"
    }
  }
});

export default EnhancedTable;
